<template>
  <Modal
    ref="modal"
    :showCloseBtn="false"
    :modalId="modalId"
    :modalType="modalType"
  >
    <div slot="content">
      <slot name="content">
        <div
          class="modal-container"
          v-for="(item, index) in formData"
          :key="index"
        >
          <div v-if="item.type === 'text'">
            <label
              class="tender-font emphasis"
              :class="{'required-flag': item.required}"
            >{{ item.label }}</label>
            <input
              type="text"
              v-model="formData[index].value"
              @input="setValidateHighlight(index)"
              :class="{
                'error-highlight': validateHighlight[index] && item.required && isEmptyValue(formData[index].value)
              }"
              :required="item.required"
            >
          </div>
          <div
            v-else-if="item.type === 'multiSelect'"
            class="multi-select"
          >
            <label
              class="tender-font emphasis"
              :class="{'required-flag': item.required}"
            >{{ item.label }}</label>
            <HKLSelect
              :class="{
                'error-highlight': validateHighlight[index] && item.required && isEmptyValue(formData[index].value)
              }"
              :value="formData[index].value || undefined"
              :options="getMultiSelectHklOptions(item)"
              :showSearch="true"
              :required="item.required"
              placeholder=""
              @change="val => onMultiSelectChange(index, val)"
            />
          </div>
        </div>
        <span
          class="form-error is-visible appr-error-message"
          v-if="errHint"
        >
          {{ errHint }}
        </span>
      </slot>
    </div>
    <div slot="btns">
      <button
        type="button"
        class="btn btn--darkblue"
        @click="close()"
      >
        {{ cancelBtnName }}
      </button>
      <button
        type="button"
        class="btn btn--orange"
        @click="confirm()"
      >
        {{ confirmBtnName }}
      </button>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/controls/Modal'
import HKLSelect from '@/controls/Select/HKLSelect.vue'
import i18n from '@/utils/i18n'
import { utils as formUtils } from '@/plugin/InputChange'

export default {
  name: 'SimpleFormModal',
  data: function () {
    return {
      formData: this.form,
      errHint: '',
      validateHighlight: [],
      confirmCallback: {
        type: Function,
        default: () => {},
      },
      params: {
        type: Array,
        default: [],
      },
    }
  },
  components: {
    Modal,
    HKLSelect,
  },
  props: {
    form: {
      type: Array,
      default: () => [],
    },
    modalId: {
      type: String,
    },
    modalType: {
      type: String,
      default: 'small-modal', // medium-modal large-modal
    },
    cancelBtnName: {
      type: String,
      default: i18n.t('action.cancel'),
    },
    confirmBtnName: {
      type: String,
      default: i18n.t('action.yesContinue'),
    },
  },
  methods: {
    getMultiSelectHklOptions (item) {
      return (item.options || []).map((opt) => {
        const value = typeof opt === 'string'
          ? opt
          : (opt.val != null ? opt.val : (opt.value != null ? opt.value : opt))
        const name = item.customLabel ? item.customLabel(value) : String(value)
        return { name, value }
      })
    },
    onMultiSelectChange (index, value) {
      this.formData[index].value = value || ''
      this.setValidateHighlight(index)
    },
    isEmptyValue (value) {
      return !value || value.trim().length === 0
    },
    setErrHint (hint) {
      this.errHint = hint
      return this
    },
    clearErrHint () {
      this.errHint = ''
      return this
    },
    open (confirmCallback) {
      this.confirmCallback = confirmCallback
      this.$refs.modal.open()
      return this
    },
    close () {
      this.formData.forEach((item) => {
        item.value = ''
      })
      formUtils.resetDirty()
      this.$refs.modal.close()
      return this
    },
    setValidateHighlight (index) {
      const isDirty = this.formData.some(item => item.value !== '')
      if (isDirty) {
        formUtils.setDirty()
      } else {
        formUtils.resetDirty()
      }
      this.validateHighlight[index] = false
    },
    setConfirmCallback (confirmCallback) {
      this.confirmCallback = confirmCallback
      return this
    },
    confirm () {
      this.validateHighlight = this.formData.map(item => true)
      for (const data of this.formData) {
        if (data.required && this.isEmptyValue(data.value)) {
          this.setErrHint(`${this.$i18n.t('error.checkInput')}`)
          return
        }
      }
      if (typeof this.confirmCallback === 'function') {
        let returnData = {}
        for (const data of this.formData) {
          returnData[data.name] = data.value
        }
        this.confirmCallback(returnData)
      }
    },
  },
  mounted () {
    this.validateHighlight = this.formData.map(item => false)
  },
  beforeDestroy () {
    if (this.modal) {
      this.modal.destroy()
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~styles/settings/style";
@import "~styles/popup";
.error-highlight {
  background-color: #f9ecea !important;
}

.modal-container {
  .multi-select {
    margin-bottom: 12px;
  }
  label {
    margin-top: 0;
  }
  input {
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
